import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { ApplyCouponComponent } from '../../apply-coupon/apply-coupon.component';
import { UploadBillsComponent } from '../../upload-bills/upload-bills.component';
import { MembershipDeatailsComponent } from '../../membership-deatails/membership-deatails.component';
import { ApplyForMembershipComponent } from '../../apply-for-membership/apply-for-membership.component';
import { MembershipService } from '../Services/Membership.service';
import { StatusService } from '../Services/status.service';



@Component({
  selector: 'app-memberships',
  imports: [TranslateModule, CommonModule, ApplyCouponComponent, UploadBillsComponent, MembershipDeatailsComponent, ApplyForMembershipComponent],
  templateUrl: './memberships.component.html',
  styleUrl: './memberships.component.css'
})
export class MembershipsComponent {

  id: number | null = null;
  data: any;
  membershipId: number = 0;
  private MembershipService = inject(MembershipService)
  private StatusService = inject(StatusService)
  lastMembership: any;
  latestLogNote: string = ''
  membershipData: any;
  membershipDataForUser: any;
  membershipStatus: string = '';
  isMember: boolean = localStorage.getItem("isMember") === "true"

  ngOnInit(): void {

    this.id = +localStorage.getItem('userId')!;  // assuming userId is stored in localStorage
    this.getMembershipByUserId()
    // console.log("isMember",this.isMember)
  }


  getMembershipByUserId() {
    this.MembershipService.getMembershipByUserId(this.id!).subscribe({
      next: (res: any) => {
        // this.lastMembership = res.value.items.length - 1
        this.data = res.value.items
        this.membershipDataForUser = this.data[0]
        // console.log("membershipDataForUser.isNearestExpired",this.membershipDataForUser?.isNearestExpired)
        this.membershipId = res.value.items[0]?.id;
        localStorage.setItem("membershipId", this.membershipId?.toString())
        this.membershipStatus = res.value.items[0]?.membershipStatus;
        this.StatusService.setMembershipStatus(this.membershipStatus);
        //  console.log("isMember && membershipStatus === Expired", this.isMember && this.membershipStatus === "Expired")
        //  console.log("membershipStatus === Expired",this.membershipStatus === "Expired")
        // console.log("this.membershipStatus", this.membershipStatus)
        this.updateMembershipData();
      }
    })
  }


  updateMembershipData() {
    if (!this.membershipId) return;

    this.MembershipService.getMemberShipById(this.membershipId).subscribe({
      next: (res: any) => {
        this.membershipData = res.value;
        // console.log("Updated membershipData:", this.membershipData);
      },
      error: (err) => console.error("Error fetching membership by ID", err)
    });
  }


}
